import { utils, writeFileXLSX } from "xlsx";

export const importTemplateGenerator = (
  columns,
  dataType,
  dimensions = [],
  hasSplitColumns = false,
  isRemoveFirtAndLastCols = false
) => {
  let columnToUse = isRemoveFirtAndLastCols ? columns.slice(1, -1) : columns; // Remove first and last columns
  let templateData = [];
  if (!hasSplitColumns) {
    templateData = [columnToUse.map((col) => col.title.split(" ").join(""))]; // Create an array for headers
  } else {
    templateData = [
      columnToUse.map((col) =>
        col.title === "Employee No" ? col.title.split(" ").join("") : col.title
      ),
    ]; // Create an array for headers
  }
  const sampleDataRow = columnToUse.map((col) => col.sampleValue || ""); // Create an array for sample data

  templateData.push(sampleDataRow); // Push the sample data array as the second row

  const ws = utils.aoa_to_sheet(templateData); // Convert arrays to worksheet
  const wb = utils.book_new();


   // Add dropdown validation to the first column (A2 to A1048576, to cover all rows)
  /* const validation = {
    type: "list",
    allowBlank: true,
    formula1: '"Option 1, Option 2, Option 3"',
  };
  utils.sheet_add_data_validation(ws, {
    range: { s: { c: 0, r: 1 }, e: { c: 0, r: 1048575 } }, // A2 to A1048576
    validation: validation,
  });
*/
  // Add the 'Info' Worksheet
  const infoData = [
    [
      `This template is designed for capturing ${dataType} data within your organization.`,
    ],
    [
      "The first row contains column headers, and it is crucial that these headers remain unaltered to ensure a successful bulk upload process.",
    ],
    [
      `For guidance on how to complete the template, please consult the sample data provided in the second row of the ${dataType} sheet. This will assist you in accurately populating your organization's ${dataType} data.`,
    ],
  ];

  const infoWs = utils.aoa_to_sheet(infoData);

  // Apply styling to the 'Info' Worksheet
  const infoStyle = {
    font: {
      name: "Arial",
      bold: true,
      size: 12,
      color: { rgb: "FFFFFF" }, // White text color
    },
    fill: {
      fgColor: { rgb: "007ACC" }, // Blue theme color
    },
    alignment: {
      vertical: "center",
      horizontal: "center",
    },
    border: {
      top: { style: "thin", color: { rgb: "000000" } }, // Black border
      bottom: { style: "thin", color: { rgb: "000000" } }, // Black border
    },
  };

  utils.format_cell(infoWs, { "!ref": infoWs["!ref"] }, infoStyle);
  utils.book_append_sheet(wb, infoWs, "Info");

  // Add template worksheet
  utils.book_append_sheet(wb, ws, dataType);

  // Add dimensions
  dimensions.forEach((dimension) => {
    if (dimension.data && dimension.headers) {
      const dimensionData = [dimension.headers]; // Table headers
      dimension.data.forEach((item) => {
        dimensionData.push(item); // Example data
      });

      const dimensionWs = utils.aoa_to_sheet(dimensionData);

      // Apply styling to the dimension Worksheet
      const dimensionStyle = {
        font: {
          name: "Arial",
          bold: true,
          size: 12,
        },
      };

      utils.format_cell(
        dimensionWs,
        { "!ref": dimensionWs["!ref"] },
        dimensionStyle
      );
      utils.book_append_sheet(wb, dimensionWs, dimension.name); // Use dimension name as sheet name
    }
  });

  writeFileXLSX(wb, `${dataType}-template.xlsx`);
};
